export default "__VITE_ASSET__DNfXR09___"